<template>
  <div class="manage-main-box">
    <Bread :breadConfig="breadConfig" />
    <div class="eol-container-box">
      <div class="search-all-box">
        <a-form-model layout="inline" ref="ruleForm" :model="form">

          <a-form-model-item prop="type">
            <a-select v-model="form.type" placeholder="请选择题型" style="width: 140px" class="multiple-select" dropdownClassName="multipleDrop">
              <a-select-option value="">请选择题型</a-select-option>
              <a-select-option v-for="(item, index) in typeArr" :key="index" :value="item.id">{{ item.name }}</a-select-option>
            </a-select>
          </a-form-model-item>
          <a-form-model-item prop="level">
            <a-select v-model="form.level" placeholder="请选择难度" style="width: 120px" class="multiple-select" dropdownClassName="multipleDrop">
              <a-select-option value="">请选择难度</a-select-option>
              <a-select-option v-for="(item, index) in levelArr" :key="index" :value="item.id">{{ item.name }}</a-select-option>
            </a-select>
          </a-form-model-item>
          <a-form-model-item prop="course_id">
            <a-select v-model="form.course_id" placeholder="请选择所属课程" style="width: 160px" class="multiple-select" dropdownClassName="multipleDrop">
              <a-select-option value="">请选择所属课程</a-select-option>
              <a-select-option v-for="(item, index) in schoolTrainCourse" :key="index" :value="item.id">{{ item.name }}</a-select-option>
            </a-select>
          </a-form-model-item>

          <a-form-model-item prop="content">
            <a-input v-model="form.content" class="search-input" placeholder="请输入题干"></a-input>
          </a-form-model-item>
          <a-form-model-item>
            <a-button class="search-btn" type="primary" @click="onSearch">搜索</a-button>
            <a-button class="reset-btn" @click="resetForm">重置</a-button>
          </a-form-model-item>
        </a-form-model>
      </div>

      <div class="table-all-box">
        <a-table :columns="columns" :data-source="tableData" :bordered="false" size="small" rowKey="id" :pagination="false">
          <template slot="content" slot-scope="text">
            <a class="link-name" href="#" v-html="text"></a>
          </template>
          <template slot="action" slot-scope="row, scope">
            <a-button type="link" @click="previewOption(scope)">查看</a-button>
          </template>
        </a-table>

        <a-pagination class="school-pagination" v-model="page" :total="totalNum" @change="pageChange" show-less-items />
      </div>
    </div>

    <CommonModal v-model="showModal" :title="modalTitle" :showCancel="false" :showConfirm="false">
      <div v-if="currentQuestion" class="question-box">
        <!-- single 单选  multiple 多选 judge 判断 -->
        <div :class='["ques-items", currentQuestion.type == 1 ? "single" : currentQuestion.type == 2 ? "multiple" :"judge"]'>
          <div class="ques-body">
            <div class="body-text" v-html="currentQuestion.content">
            </div>
          </div>
          <div v-if="currentQuestion.type < 3" class="ques-options">
            <div v-for="(item, index) in currentQuestion.items" :key="index" :class='["opt-item", item.is_right == 1 ? "checked" : ""]'>
              <div class="opt-icon"></div>{{ String.fromCharCode(index + 65) }}、<span v-html="item.content"></span>
            </div>
          </div>

          <div v-if="currentQuestion.type == 3" class="answer-line">
            <div class="answer-icon"></div>
            <div class="answer-item">正确答案：{{currentQuestion.is_right == 1 ? "对" : "错"}}</div>
          </div>
          <div v-else class="answer-line">
            <div class="answer-icon"></div>
            <div class="answer-item">正确答案：
              <template v-for="(answer, aindex) in currentQuestion.items">
                <template v-if="answer.is_right == 1">
                  {{String.fromCharCode(aindex + 65)}}
                </template>
              </template>
            </div>
          </div>
        </div>

      </div>
    </CommonModal>
  </div>
</template>
<script>
import { mapActions, mapState } from "vuex";
import Bread from "../../../../components/school/Bread.vue";
import CommonModal from "../../../../components/CommonModal"
export default {
  components: {
    Bread, CommonModal
  },
  data () {
    return {
      breadConfig: [
        { name: "实践资源库" },
        { name: "试题资源" },
      ],
      page: 1,
      size: 10,
      totalNum: 0,
      tableData: [],
      form: {
        content: "",
        type: '',
        level: '',
        course_id: '',
      },
      levelArr: [
        { id: 1, name: '低' },
        { id: 2, name: '中' },
        { id: 3, name: '高' }
      ],
      typeArr: [
        { id: 1, name: '单选题' },
        { id: 2, name: '多选题' },
        { id: 3, name: '判断题' }
      ],
      columns: [
        {
          title: "题干",
          dataIndex: "content",
          scopedSlots: {
            customRender: 'content'
          }
        },
        {
          title: "所属课程",
          dataIndex: "course_name",
        },
        {
          title: "题型",
          dataIndex: "type_name",
        },
        {
          title: "难度",
          dataIndex: "level_name",
        },
        {
          title: "创建时间",
          dataIndex: "updated_at",
        },
        {
          title: "操作",
          dataIndex: "action",
          scopedSlots: { customRender: 'action' },
          align: 'center',
        },
      ],
      showModal: false,
      modalTitle: '查看试题',
      currentQuestion: null,
    };
  },
  computed: {
    ...mapState({
      schoolTrainCourse: state => state.resourceLibrary.schoolTrainCourse, // 课程列表 
    }),
  },
  mounted () {
    this.getSchoolTrainCourse()
    this.getTableList()
  },
  methods: {
    ...mapActions(['getSchoolTrainCourse', "getCourseQuestion", "getCourseQuestionDetail"]),
    getTableList () {
      let params = {
        page: this.page,
        size: this.size,
        content: this.form.content,
        type: this.form.type,
        level: this.form.level,
        course_id: this.form.course_id,
      };
      this.getCourseQuestion(params).then((res) => {
        if (res.code == "0000" && res.data) {
          this.tableData = res.data.items;
          this.totalNum = res.data.total;
          // console.log(res.data)
        }
      });
    },
    onSearch () {
      this.page = 1;
      this.total = 0;
      this.getTableList();
    },
    pageChange (val) {
      this.page = val;
      this.total = 0;
      this.getTableList();
    },
    resetForm () {
      this.$refs.ruleForm.resetFields();
      this.onSearch()
    },
    // 预览试题
    previewOption (item) {
      let that = this
      console.log(item)
      that.showModal = true
      that.modalTitle = item.type_name
      that.getCourseQuestionDetail({ id: item.id }).then((res) => {
        if (res.code == "0000" && res.data) {
          that.currentQuestion = res.data
          that.currentQuestion.type = item.type_name == "单选题" ? 1 : item.type_name == "多选题" ? 2 : 3
          console.log(that.currentQuestion)
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.question-box {
    .ques-items {
        padding: 20px 15px 0;
        border-bottom: 1px solid #eef1f3;
        &:last-child {
            border-bottom: none;
        }
        .ques-body {
            font-weight: 400;
            display: flex;
            font-size: 14px;
            line-height: 20px;
            margin-bottom: 15px;
            .label-line {
                color: #a82822;
                display: inline-block;
            }
            .body-text {
                color: #302e2f;
                display: inline-block;
                span {
                    color: #a82822;
                }
            }
        }
        .ques-options {
            .opt-item {
                font-size: 14px;
                color: #777b85;
                margin-bottom: 10px;
                cursor: pointer;
                .opt-icon {
                    display: inline-block;
                    margin-right: 10px;
                    width: 14px;
                    height: 14px;
                    background: url('../../../../assets/image/student/stepFour/unitOne/radio.png')
                        no-repeat center;
                    background-size: cover;
                    vertical-align: -2px;
                }
                /deep/ p {
                    display: inline !important;
                }
            }
        }
        &.single {
            .opt-item .opt-icon {
                background: url('../../../../assets/image/student/stepFour/unitOne/radio.png')
                    no-repeat center;
                background-size: cover;
            }
            .opt-item.checked {
                color: #cd6b06;
            }
            .opt-item.checked .opt-icon {
                background: url('../../../../assets/image/student/stepFour/unitOne/radio-active.png')
                    no-repeat center;
                background-size: cover;
            }
        }
        &.multiple {
            .opt-item .opt-icon {
                background: url('../../../../assets/image/student/stepFour/unitOne/checkbox.png')
                    no-repeat center;
                background-size: cover;
            }
            .opt-item.checked {
                color: #cd6b06;
            }

            .opt-item.checked .opt-icon {
                background: url('../../../../assets/image/student/stepFour/unitOne/checkbox-active.png')
                    no-repeat center;
                background-size: cover;
            }
        }
        .judge-list {
            display: block;
            margin-bottom: 10px;
            .judge-item {
                cursor: pointer;
                display: inline-block;
                margin-right: 24px;
                width: 140px;
                height: 30px;
                line-height: 28px;
                text-align: center;
                background: #ffffff;
                border-radius: 15px;
                border: 1px solid #d8dbe1;
                font-size: 14px;
                color: #777b85;
                &:hover,
                &.checked {
                    color: #cd6b06;
                    background: #fff6ed;
                    border: 1px solid #d7b9a4;
                }
                &::before {
                    content: '';
                    display: inline-block;
                    margin-right: 10px;
                    width: 14px;
                    height: 14px;
                    background: url('../../../../assets/image/student/stepFour/unitOne/radio.png')
                        no-repeat center;
                    background-size: cover;
                    vertical-align: -2px;
                }
                &.checked::before {
                    background: url('../../../../assets/image/student/stepFour/unitOne/radio-active.png')
                        no-repeat center;
                    background-size: cover;
                }
            }
        }
        .answer-line {
            padding: 5px 0 5px 12px;
            background-color: #ecfbf7;
            .answer-icon {
                width: 17px;
                height: 17px;
                display: inline-block;
                margin-right: 12px;
                background: url('../../../../assets/image/student/stepFour/unitOne/right.png')
                    no-repeat center;
                background-size: cover;
                vertical-align: -3px;
            }
            .answer-item {
                display: inline-block;
                font-weight: 400;
                font-size: 14px;
                color: #91959f;
                margin-right: 30px;
            }
        }
        &.right {
            .answer-icon {
                background: url('../../../../assets/image/student/stepFour/unitOne/right.png')
                    no-repeat center;
                background-size: cover;
            }
        }
        &.error {
            background-color: #fff8f8;
            .answer-icon {
                background: url('../../../../assets/image/student/stepFour/unitOne/error.png')
                    no-repeat center;
                background-size: cover;
            }
        }
    }
}
</style>